import React, {useEffect} from 'react';

import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingleBFR from '../../partials/BlogSingleBFR';
import Footer from '../../partials/Footer';

function BlogPostBFR() {

  useEffect(() => {
    document.title = `PME : Plus jamais à court d'argent ! Maîtrisez votre BFR en 5 étapes. | CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingleBFR />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostBFR;